import { render, staticRenderFns } from "./TotalTurnoverChart.vue?vue&type=template&id=57e8c56c"
import script from "./TotalTurnoverChart.vue?vue&type=script&lang=js"
export * from "./TotalTurnoverChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports